








import { Component, Prop, Vue } from 'vue-property-decorator'
import { LocaleMessage } from 'vue-i18n'
import SkillBar from '@/components/SkillBar.vue'

export interface Item {
  skill: string|LocaleMessage
  value: number
}

@Component({
  name: 'Skills',
  components: {
    SkillBar
  }
})
export default class Timeline extends Vue {
  $mq: any
  delays: number[]

  constructor () {
    super()
    this.delays = []
  }

  get items () {
    return [
      {
        name: 'AWS',
        value: 0.85
      },
      {
        name: 'Go',
        value: 0.92
      },
      {
        name: 'Rust',
        value: 0.55
      },
      {
        name: 'Modern C++',
        value: 0.87
      },
      {
        name: 'C',
        value: 0.85
      },
      {
        name: 'Docker/Terraform',
        value: 0.8
      }
    ]
  }

  mounted () {
    this.delays = new Array(this.items.length).fill(80)
  }

  resetDelays () {
    for (const i in this.delays) {
      Vue.set(this.delays, i, 80)
    }
  }

  revealItems () {
    const items = this.items ? this.items.length : 0
    let sum = 500
    let j = 0
    for (const i in this.items) {
      sum += this.delays[i]
      setTimeout(() => {
        Vue.set(this.delays, i, 0)
      }, sum)
    }
  }

  visibilityChanged (isVisible: boolean, entry: any) {
    if (isVisible) {
      this.revealItems()
    } else if (entry.boundingClientRect.top >= 0) {
      this.resetDelays()
    }
  }
}
